// extracted by mini-css-extract-plugin
export default {"box":"style_box__kYUtm","focus":"style_focus__lV980"};